const CART_KEY = "trueMomentCart";
const PRODUCTS_KEY = "trueMomentStaffProducts";
const MEMBER_KEY = "trueMomentMember";
const THEME_KEY = "trueMomentTheme";
const STORE_PHONE = "85246789215";
const checkoutState = {
  fulfillment: "門市預留",
  customerName: "",
  customerPhone: "",
  coupon: "",
  note: "",
};

function readCart() {
  try {
    return JSON.parse(localStorage.getItem(CART_KEY)) || [];
  } catch {
    return [];
  }
}

function saveCart(items) {
  localStorage.setItem(CART_KEY, JSON.stringify(items));
}

function readStaffProducts() {
  try {
    return JSON.parse(localStorage.getItem(PRODUCTS_KEY)) || [];
  } catch {
    return [];
  }
}

function saveStaffProducts(products) {
  localStorage.setItem(PRODUCTS_KEY, JSON.stringify(products));
}

function readMember() {
  try {
    return JSON.parse(localStorage.getItem(MEMBER_KEY));
  } catch {
    return null;
  }
}

function saveMember(member) {
  localStorage.setItem(MEMBER_KEY, JSON.stringify(member));
}

function currentTheme() {
  return localStorage.getItem(THEME_KEY) || "day";
}

function applyTheme(theme) {
  document.documentElement.dataset.theme = theme;
  const button = document.querySelector("[data-theme-toggle]");
  if (button) {
    button.innerHTML =
      theme === "night"
        ? '<svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>'
        : '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M21 14.5A7.5 7.5 0 0 1 9.5 3a9 9 0 1 0 11.5 11.5Z"/></svg>';
    button.setAttribute("aria-label", theme === "night" ? "切換至日間模式" : "切換至夜間模式");
  }
}

function setupThemeToggle() {
  applyTheme(currentTheme());

  const button = document.createElement("button");
  button.className = "theme-toggle";
  button.type = "button";
  button.dataset.themeToggle = "";
  document.body.appendChild(button);
  applyTheme(currentTheme());

  button.addEventListener("click", () => {
    const nextTheme = currentTheme() === "night" ? "day" : "night";
    localStorage.setItem(THEME_KEY, nextTheme);
    applyTheme(nextTheme);
  });
}

if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

function memberTier(points) {
  if (points >= 4000) return "Platinum";
  if (points >= 2000) return "Diamond";
  if (points >= 1000) return "Gold";
  if (points >= 500) return "Silver";
  return "Basic";
}

function tierDiscountRate(tier) {
  if (tier === "Platinum") return 0.3;
  if (tier === "Diamond") return 0.25;
  if (tier === "Gold") return 0.2;
  if (tier === "Silver") return 0.15;
  return 0;
}

function tierCouponCode(tier) {
  if (tier === "Platinum") return "PLATINUM30";
  if (tier === "Diamond") return "DIAMOND25";
  if (tier === "Gold") return "GOLD20";
  if (tier === "Silver") return "SILVER15";
  return "";
}

function tierBenefitCopy(tier) {
  if (tier === "Platinum") return "Platinum 專屬 7 折優惠券、VIP 私人留貨、季度造型禮遇。";
  if (tier === "Diamond") return "Diamond 新品優先預留、專屬 75 折優惠券。";
  if (tier === "Gold") return "Gold 正價貨品 8 折、免費門市預留。";
  if (tier === "Silver") return "Silver 專屬 85 折優惠券、生日禮、優先新品通知。";
  return "Basic 會員可保存訂單紀錄、收藏商品和累積積分。";
}

function createMember({ name = "Chan M.", phone = "9123 4567", email = "", birthdayMonth = "7 月", points = 1280, tier = "" } = {}) {
  const resolvedTier = tier || memberTier(points);
  return {
    id: "TM-0826",
    name,
    phone,
    email,
    birthdayMonth,
    points,
    tier: resolvedTier,
    loggedInAt: new Date().toISOString(),
  };
}

function escapeHtml(value) {
  return String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

function productPrice(product) {
  return product.sale && product.salePrice ? Number(product.salePrice) : Number(product.price);
}

function productStatus(product) {
  if (!product.published) return '<mark>草稿</mark>';
  if (product.sale) return '<mark class="warn">SALE</mark>';
  return '<mark class="ok">已上架</mark>';
}

function getSelectedOption(name, fallback) {
  return document.querySelector(`input[name="${name}"]:checked`)?.value || fallback;
}

function formatPrice(value) {
  return `HK$ ${value.toLocaleString("zh-HK")}`;
}

function cartSubtotal(items) {
  return items.reduce((sum, item) => sum + item.price * item.qty, 0);
}

function getDiscount(subtotal) {
  const member = readMember();
  const tierRate = member ? tierDiscountRate(member.tier) : 0;
  if (tierRate > 0) {
    return Math.round(subtotal * tierRate);
  }

  const couponRates = {
    SILVER15: 0.15,
    GOLD20: 0.2,
    DIAMOND25: 0.25,
    PLATINUM30: 0.3,
  };
  const couponRate = couponRates[checkoutState.coupon.trim().toUpperCase()] || 0;
  if (couponRate > 0) {
    return Math.round(subtotal * couponRate);
  }
  return 0;
}

function getFulfillmentFee() {
  const subtotal = cartSubtotal(readCart());
  const isSfDelivery = checkoutState.fulfillment === "順豐站 / 順豐智能櫃";
  return isSfDelivery && subtotal < 500 ? 40 : 0;
}

function cartTotal(items) {
  const subtotal = cartSubtotal(items);
  return Math.max(0, subtotal - getDiscount(subtotal) + getFulfillmentFee());
}

function buildWhatsAppMessage(items) {
  const member = readMember();
  if (items.length === 0) {
    return "你好 TRUE MOMENT，我想查詢商品及門市預留。";
  }

  const lines = items.map((item) => `- ${item.name} / ${item.color} / ${item.size} / x${item.qty} / ${formatPrice(item.price * item.qty)}`);
  const subtotal = cartSubtotal(items);
  const discount = getDiscount(subtotal);
  const fee = getFulfillmentFee();
  const customerLines = [
    member && `會員：${member.name}（${member.tier} Member）`,
    checkoutState.customerName && `姓名：${checkoutState.customerName}`,
    checkoutState.customerPhone && `電話：${checkoutState.customerPhone}`,
    checkoutState.note && `備註：${checkoutState.note}`,
  ].filter(Boolean);

  return `你好 TRUE MOMENT，我想預留以下商品：\n${lines.join("\n")}\n取貨方式：${checkoutState.fulfillment}\n${customerLines.join("\n")}${customerLines.length ? "\n" : ""}商品小計：${formatPrice(subtotal)}\n優惠折扣：-${formatPrice(discount)}\n配送/預留費：${fee === 0 ? "免費" : formatPrice(fee)}\n總額：${formatPrice(cartTotal(items))}\n我想確認門市試身、順豐站 / 順豐智能櫃取貨或付款安排。`;
}

function setupMemberAuth() {
  const loginForm = document.querySelector("[data-member-login-form]");
  const registerForm = document.querySelector("[data-member-register-form]");

  loginForm?.addEventListener("submit", (event) => {
    event.preventDefault();
    const contact = loginForm.querySelector('[data-member-login-field="contact"]').value.trim();
    saveMember(createMember({ phone: contact || "9123 4567" }));
    window.location.href = "member-dashboard.html";
  });

  registerForm?.addEventListener("submit", (event) => {
    event.preventDefault();
    const getField = (field) => registerForm.querySelector(`[data-member-register-field="${field}"]`);
    saveMember(
      createMember({
        name: getField("name").value.trim() || "New Member",
        phone: getField("phone").value.trim() || "9123 4567",
        email: getField("email").value.trim(),
        birthdayMonth: getField("birthdayMonth").value || "請選擇",
        points: 0,
      }),
    );
    window.location.href = "member-dashboard.html";
  });
}

function setupStaffMemberForm() {
  const form = document.querySelector("[data-staff-member-form]");
  if (!form) return;

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const getField = (field) => form.querySelector(`[data-staff-member-field="${field}"]`);
    const points = Number(getField("points").value) || 0;
    const member = createMember({
      name: getField("name").value.trim() || "Walk-in Customer",
      phone: getField("phone").value.trim() || "未提供",
      birthdayMonth: getField("birthdayMonth").value,
      points,
      tier: getField("tier").value,
    });
    saveMember(member);
    renderStaffMemberResult(member);
    document.querySelector("[data-staff-member-status]").textContent = `已建立 / 更新會員：${member.name}，${member.tier} Member，初次積分 ${member.points.toLocaleString("zh-HK")}。`;
  });
}

function renderStaffMemberResult(member = readMember()) {
  const result = document.querySelector("[data-staff-member-result]");
  if (!result) return;

  if (!member) {
    result.innerHTML = `
      <strong>尚未建立會員</strong>
      <span>客人首次購物後，可在上方輸入資料並建立會員。</span>
    `;
    return;
  }

  const coupon = tierCouponCode(member.tier);
  result.innerHTML = `
    <strong>${escapeHtml(member.tier)} 會員：${escapeHtml(member.name)}</strong>
    <span>會員編號 ${escapeHtml(member.id)}，電話 ${escapeHtml(member.phone)}，積分 ${Number(member.points).toLocaleString("zh-HK")}。${coupon ? `會員優惠券 ${coupon}。` : "Basic 會員暫無等級折扣優惠券。"}</span>
  `;
}

function renderMemberDashboard() {
  const nameNode = document.querySelector("[data-member-name]");
  if (!nameNode) return;

  const member = readMember() || createMember();
  nameNode.textContent = member.name;
  document.querySelector("[data-member-tier]").textContent = member.tier;
  document.querySelector("[data-member-id]").textContent = member.id;
  document.querySelector("[data-member-points]").textContent = member.points.toLocaleString("zh-HK");

  const nextTier = member.points >= 4000 ? "最高等級" : member.points >= 2000 ? "Platinum" : member.points >= 1000 ? "Diamond" : member.points >= 500 ? "Gold" : "Silver";
  const nextTarget = member.points >= 4000 ? 4000 : member.points >= 2000 ? 4000 : member.points >= 1000 ? 2000 : member.points >= 500 ? 1000 : 500;
  const nextCopy = member.points >= 4000 ? "已達 Platinum 最高會員等級" : `距離 ${nextTier} 還差 ${(nextTarget - member.points).toLocaleString("zh-HK")} 分`;
  document.querySelector("[data-next-tier-copy]").textContent = nextCopy;
  const progress = document.querySelector("[data-member-progress]");
  progress.value = Math.min(member.points, nextTarget);
  progress.max = nextTarget;

  document.querySelector("[data-tier-coupon-title]").textContent = `${member.tier} Member 禮遇`;
  document.querySelector("[data-tier-coupon-note]").textContent = tierBenefitCopy(member.tier);
  const couponCodeNode = document.querySelector("[data-tier-coupon-code]");
  const code = tierCouponCode(member.tier);
  couponCodeNode.textContent = code ? `優惠券：${code}` : "";
  couponCodeNode.hidden = !code;
  document.querySelector("[data-birthday-coupon-title]").textContent = "生日禮 HK$100";
  document.querySelector("[data-birthday-coupon-note]").textContent = `${member.birthdayMonth} 生日月份有效。`;
  document.querySelector("[data-birthday-activity]").textContent = `${member.birthdayMonth} 生日月份登入`;
  document.querySelectorAll("[data-tier-card]").forEach((card) => {
    card.classList.toggle("current-tier", card.dataset.tierCard === member.tier);
  });
}

function renderCheckoutMember() {
  const card = document.querySelector("[data-checkout-member-card]");
  if (!card) return;

  const member = readMember();
  const nameNode = document.querySelector("[data-checkout-member-name]");
  const benefitNode = document.querySelector("[data-checkout-member-benefit]");
  const linkNode = document.querySelector("[data-checkout-member-link]");

  if (!member) {
    nameNode.textContent = "Walk-in 客人";
    benefitNode.textContent = "登入會員後可自動套用會員優惠。";
    linkNode.textContent = "登入 / 註冊";
    linkNode.href = "member-auth.html";
    return;
  }

  nameNode.textContent = `${member.name} · ${member.tier} Member`;
  benefitNode.textContent = tierDiscountRate(member.tier) > 0 ? `已自動套用 ${tierBenefitCopy(member.tier)}` : tierBenefitCopy(member.tier);
  linkNode.textContent = "查看會員中心";
  linkNode.href = "member-dashboard.html";
}

function prefillCheckoutMember() {
  const member = readMember();
  if (!member) return;

  const nameField = document.querySelector('[data-checkout-field="customerName"]');
  const phoneField = document.querySelector('[data-checkout-field="customerPhone"]');
  if (nameField && !nameField.value) nameField.value = member.name;
  if (phoneField && !phoneField.value) phoneField.value = member.phone;
}

function updateCartCount(items) {
  const count = items.reduce((sum, item) => sum + item.qty, 0);
  document.querySelectorAll("[data-cart-count]").forEach((node) => {
    node.textContent = String(count);
  });
}

function updateTotals(items) {
  const subtotal = cartSubtotal(items);
  const discount = getDiscount(subtotal);
  const fee = getFulfillmentFee();
  const total = cartTotal(items);
  document.querySelectorAll("[data-cart-subtotal]").forEach((node) => {
    node.textContent = formatPrice(subtotal);
  });
  document.querySelectorAll("[data-discount-total]").forEach((node) => {
    node.textContent = discount > 0 ? `-${formatPrice(discount)}` : "HK$ 0";
  });
  document.querySelectorAll("[data-fulfillment-label]").forEach((node) => {
    node.textContent = checkoutState.fulfillment;
  });
  document.querySelectorAll("[data-fulfillment-fee]").forEach((node) => {
    node.textContent = fee === 0 ? "免費" : formatPrice(fee);
  });
  document.querySelectorAll("[data-cart-total]").forEach((node) => {
    node.textContent = formatPrice(total);
  });
}

function updateWhatsApp(items) {
  const message = encodeURIComponent(buildWhatsAppMessage(items));
  document.querySelectorAll("[data-whatsapp-link]").forEach((link) => {
    link.href = `https://wa.me/${STORE_PHONE}?text=${message}`;
    link.target = "_blank";
    link.rel = "noopener";
  });
}

function addToCartFromButton(button) {
  const items = readCart();
  const name = button.dataset.name;
  const price = Number(button.dataset.price);
  const color = button.hasAttribute("data-product-options") ? getSelectedOption("color", "Cream") : button.dataset.color || "Cream";
  const size = button.hasAttribute("data-product-options") ? getSelectedOption("size", "M") : button.dataset.size || "M";
  const key = `${name}-${color}-${size}`;
  const existing = items.find((item) => item.key === key);

  if (existing) {
    existing.qty += 1;
  } else {
    items.push({ key, name, price, color, size, qty: 1 });
  }

  saveCart(items);
  renderCart();
  button.textContent = "已加入";
  setTimeout(() => {
    button.textContent = "加入購物車";
  }, 900);
}

function buildCatalogCard(product) {
  const price = productPrice(product);
  const priceText = product.sale && product.salePrice ? `<del>${formatPrice(Number(product.price))}</del> ${formatPrice(price)}` : formatPrice(price);
  const category = product.sale ? `SALE / ${product.category}` : product.category;
  const cardClass = product.sale ? "catalog-card sale-card" : "catalog-card";

  return `
    <article class="${cardClass}" data-staff-product-card>
      <a href="product-detail.html">
        <img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.name)}" />
      </a>
      <div>
        <span>${escapeHtml(category)}</span>
        <h2>${escapeHtml(product.name)}</h2>
        <p>${priceText}</p>
        <button class="add-cart" data-name="${escapeHtml(product.name)}" data-price="${price}" data-size="${escapeHtml(product.size)}" data-color="${escapeHtml(product.color)}">加入購物車</button>
      </div>
    </article>
  `;
}

function renderCatalogProducts() {
  const grid = document.querySelector("[data-catalog-grid]");
  if (!grid) return;

  grid.querySelectorAll("[data-staff-product-card]").forEach((card) => card.remove());

  const products = readStaffProducts().filter((product) => product.published);
  const regularProducts = products.filter((product) => !product.sale);
  const saleProducts = products.filter((product) => product.sale);
  const firstSaleCard = grid.querySelector(".sale-card");

  regularProducts.forEach((product) => {
    const template = document.createElement("template");
    template.innerHTML = buildCatalogCard(product).trim();
    grid.insertBefore(template.content.firstElementChild, firstSaleCard);
  });

  saleProducts.forEach((product) => {
    const template = document.createElement("template");
    template.innerHTML = buildCatalogCard(product).trim();
    grid.appendChild(template.content.firstElementChild);
  });
}

function renderAdminProducts() {
  const table = document.querySelector("[data-admin-product-list]");
  if (!table) return;

  table.querySelectorAll("[data-staff-product-row]").forEach((row) => row.remove());

  readStaffProducts().forEach((product) => {
    const row = document.createElement("div");
    row.className = "admin-row";
    row.dataset.staffProductRow = "";
    row.innerHTML = `
      <span>${escapeHtml(product.name)}</span>
      <span>${escapeHtml(product.sale ? `SALE / ${product.category}` : product.category)}</span>
      <span>${productStatus(product)}</span>
      <span>${product.sale && product.salePrice ? `<del>${formatPrice(Number(product.price))}</del> ${formatPrice(Number(product.salePrice))}` : formatPrice(Number(product.price))}</span>
    `;
    table.appendChild(row);
  });
}

function setupProductEditor() {
  const form = document.querySelector("[data-product-editor-form]");
  if (!form) return;

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const getField = (field) => form.querySelector(`[data-product-field="${field}"]`);
    const name = getField("name").value.trim();
    const price = Number(getField("price").value);
    const image = getField("image").value.trim();
    const status = document.querySelector("[data-product-form-status]");

    if (!name || !price || !image) {
      status.textContent = "請先填寫商品名稱、正價和圖片網址。";
      return;
    }

    const product = {
      id: `staff-${Date.now()}`,
      name,
      category: getField("category").value,
      price,
      salePrice: Number(getField("salePrice").value) || "",
      size: getField("size").value,
      color: getField("color").value,
      image,
      description: getField("description").value.trim(),
      published: getField("published").checked,
      sale: getField("sale").checked,
    };

    const products = readStaffProducts();
    products.unshift(product);
    saveStaffProducts(products);
    renderAdminProducts();
    status.textContent = product.published ? "已發布，顧客商品列表會顯示這件商品。" : "已儲存為草稿，暫不顯示在顧客版。";
  });
}

function renderMiniCart(items) {
  const listNode = document.querySelector("[data-cart-list]");
  if (!listNode) return;

  if (items.length === 0) {
    listNode.innerHTML = "<p>尚未加入商品。可先用作「預留試身」或之後接正式付款。</p>";
    return;
  }

  listNode.innerHTML = items
    .map(
      (item) => `
        <div class="cart-item">
          <span>${item.name}<em>${item.color} / ${item.size} / x${item.qty}</em></span>
          <small>${formatPrice(item.price * item.qty)}</small>
        </div>
      `,
    )
    .join("");
}

function renderCartPage(items) {
  const listNode = document.querySelector("[data-cart-page-list]");
  if (!listNode) return;

  if (items.length === 0) {
    listNode.innerHTML = `
      <div class="empty-cart">
        <strong>購物車暫時是空的</strong>
        <span>先回到新品區挑選商品，再用 WhatsApp 預留到店試身。</span>
        <a href="index.html#new-arrivals">返回新品</a>
      </div>
    `;
    return;
  }

  listNode.innerHTML = items
    .map(
      (item) => `
        <article class="cart-line" data-key="${item.key}">
          <div>
            <strong>${item.name}</strong>
            <span>${item.color} / ${item.size}</span>
            <small>${formatPrice(item.price)}</small>
          </div>
          <div class="qty-control" aria-label="調整數量">
            <button type="button" data-cart-action="decrease" data-key="${item.key}">-</button>
            <output>${item.qty}</output>
            <button type="button" data-cart-action="increase" data-key="${item.key}">+</button>
          </div>
          <button class="remove-item" type="button" data-cart-action="remove" data-key="${item.key}">刪除</button>
        </article>
      `,
    )
    .join("");
}

function changeCartItem(action, key) {
  let items = readCart();
  const item = items.find((entry) => entry.key === key);

  if (action === "increase" && item) {
    item.qty += 1;
  }

  if (action === "decrease" && item) {
    item.qty -= 1;
    if (item.qty <= 0) {
      items = items.filter((entry) => entry.key !== key);
    }
  }

  if (action === "remove") {
    items = items.filter((entry) => entry.key !== key);
  }

  saveCart(items);
  renderCart();
}

function renderCart() {
  const items = readCart();
  updateCartCount(items);
  updateTotals(items);
  updateWhatsApp(items);
  renderMiniCart(items);
  renderCartPage(items);
}

function syncCheckoutState() {
  document.querySelectorAll("[data-checkout-field]").forEach((field) => {
    checkoutState[field.dataset.checkoutField] = field.value;
  });
}

document.addEventListener("click", (event) => {
  const addCartButton = event.target.closest("[data-name][data-price]");
  if (addCartButton) {
    addToCartFromButton(addCartButton);
    return;
  }

  const button = event.target.closest("[data-cart-action]");
  if (!button) return;
  changeCartItem(button.dataset.cartAction, button.dataset.key);
});

document.querySelectorAll("[data-checkout-field]").forEach((field) => {
  field.addEventListener("input", () => {
    syncCheckoutState();
    renderCart();
  });
  field.addEventListener("change", () => {
    syncCheckoutState();
    renderCart();
  });
});

document.querySelector("[data-apply-coupon]")?.addEventListener("click", () => {
  syncCheckoutState();
  renderCart();
});

document.querySelector("[data-clear-cart]")?.addEventListener("click", () => {
  saveCart([]);
  renderCart();
});

setupThemeToggle();
syncCheckoutState();
setupProductEditor();
setupMemberAuth();
setupStaffMemberForm();
renderMemberDashboard();
prefillCheckoutMember();
syncCheckoutState();
renderCatalogProducts();
renderAdminProducts();
renderStaffMemberResult();
renderCheckoutMember();
renderCart();
